import { Component } from 'react';
import * as R from 'ramda';
import { MapNoteSheet } from '../../components';
import s from './HostStyles.module.scss';

const initialState = {
    mapNote: {
        id: 0,
        subject: 'Playground Map Note',
        noteStatus: 'open',
        noteType: 'mapRequest',
        createdBy: { email: 'test@test.com' },
        createdAt: '2019-05-06T19:00:24Z',
        comments: [
            {
                id: 0,
                type: 'comment',
                uploads: [],
                createdAt: '2019-04-26T04:25:38Z',
                body: 'Playground map note comment.',
                createdBy: { email: 'test@test.com' },
            },
            {
                id: 1,
                type: 'comment',
                uploads: [],
                createdAt: '2019-05-01T04:25:38Z',
                body: 'Playground map note second comment.',
                createdBy: { email: 'test@test.com' },
            },
            {
                id: 2,
                type: 'comment',
                uploads: ['https://locusmapsrequests.zendesk.com/attachments/token/Djl9NcHCpFB6atd26PStSA8zB/?name=IMG_2326.JPG'],
                createdAt: '2019-05-02T19:57:25Z',
                body: '',
                createdBy: { email: 'test@test.com' },
            },
            {
                id: 3,
                type: 'comment',
                uploads: ['https://locusmapsrequests.zendesk.com/attachments/token/gP9KU3vPq8Dd5f3nd6mETfAfB/?name=prod_monitoring_20190422_134738.pdf'],
                createdAt: '2019-05-03T19:57:25Z',
                body: '',
                createdBy: { email: 'test@test.com' },
            },
            {
                newValue: 'Playground Map Note',
                previousValue: 'Test Map Note',
                createdAt: '2019-05-03T21:48:58Z',
                fieldName: 'subject',
                type: 'history',
            },
            {
                newValue: 'noType',
                previousValue: 'mapRequest',
                createdAt: '2019-05-04T21:49:23Z',
                fieldName: 'noteType',
                type: 'history',
            },
            {
                newValue: 'mapRequest',
                previousValue: 'noType',
                createdAt: '2019-05-05T21:49:23Z',
                fieldName: 'noteType',
                type: 'history',
            },
            {
                newValue: 'fieldVerify',
                previousValue: 'mapRequest',
                createdAt: '2019-05-06T21:49:23Z',
                fieldName: 'noteType',
                type: 'history',
            },
            {
                newValue: 'resolved',
                previousValue: 'open',
                createdAt: '2019-05-07T21:49:23Z',
                fieldName: 'noteStatus',
                type: 'history',
            },
            {
                newValue: 'open',
                previousValue: 'resolved',
                createdAt: '2019-05-08T21:49:23Z',
                fieldName: 'noteStatus',
                type: 'history',
            },
        ],
    },
    userEmail: 'test@test.com',
    comment: '',
};

export default class MapNoteSheetEditableHost extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }

    addHistoryComment = (newVal, oldVal, field, mapNote) => {
        const formattedHistoryComment = {
            newValue: newVal,
            previousValue: oldVal,
            createdAt: new Date(),
            fieldName: field,
            type: 'history',
        };
        this.setState({ mapNote: R.assoc('comments', R.concat(mapNote.comments, [formattedHistoryComment]), mapNote) });
    };

    onStatusChange = () => {
        const { mapNote } = this.state;
        const oldNoteStatus = mapNote.noteStatus;
        const newNoteStatus = oldNoteStatus === 'open' ? 'resolved' : 'open';
        const updatedMapNote = R.assoc('noteStatus', newNoteStatus, mapNote);
        this.addHistoryComment(newNoteStatus, oldNoteStatus, 'noteType', updatedMapNote);
    };

    onCommentUpload = newComment => {
        const { mapNote } = this.state;
        const formattedComment = {
            id: R.length(R.filter(comment => comment.type === 'comment', mapNote.comments)),
            type: 'comment',
            uploads: [],
            createdAt: new Date().toISOString(),
            body: newComment,
            createdBy: { email: 'test@test.com' },
        };
        this.setState({
            mapNote: R.assoc('comments', R.concat(mapNote.comments, [formattedComment]), mapNote),
            comment: '',
        });
    };

    onImageUpload = newImages => {
        const { mapNote } = this.state;
        const addImageComment = () => ({
            id: R.length(R.filter(comment => comment.type === 'comment', mapNote.comments)),
            type: 'comment',
            uploads: ['https://locusmapsrequests.zendesk.com/attachments/token/ngMrJX7pP3bVnp4JZG76vgaYF/?name=golden-retriever-dogs-puppies-9.jpg'],
            createdAt: new Date().toISOString(),
            body: '',
            createdBy: { email: 'test@test.com' },
        });
        const newComments = R.map(addImageComment, newImages);
        this.setState({ mapNote: R.assoc('comments', R.concat(mapNote.comments, newComments), mapNote) });
    };

    onCommentDelete = commentId => {
        const { mapNote } = this.state;
        const comment = R.find(R.propEq(commentId, 'id'))(mapNote.comments);
        this.setState({ mapNote: R.assoc('comments', R.without([comment], mapNote.comments), mapNote) });
    };

    render() {
        const { mapNote } = this.state;
        const hasNote = !R.isNil(mapNote);
        return (
            <div className={s.editor} style={{ padding: '100px' }}>
                {hasNote && (
                    <MapNoteSheet
                        mapNote={this.state.mapNote}
                        comment={this.state.comment}
                        userEmail={this.state.userEmail}
                        onCommentUpload={this.onCommentUpload}
                        onImageUpload={this.onImageUpload}
                        onCommentDelete={this.onCommentDelete}
                        onStatusChange={this.onStatusChange}
                        onTrash={() => this.setState({ mapNote: null })}
                        onEdit={() => this.setState({ mapNote: null })}
                        onClose={() => this.setState({ mapNote: null })}
                        onCommentChange={changedComment => this.setState({ comment: changedComment })}
                    />
                )}
                <button type="button" onClick={() => this.setState(initialState)} className={s.resetButton}>
                    Reset
                </button>
            </div>
        );
    }
}
